/* unplugin-vue-components disabled */import script from "./teamManage.vue?vue&type=script&setup=true&lang=ts"
export * from "./teamManage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__